module.exports = __webpack_public_path__ + "static/img/08哇哦.6d25c65.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/08哇哦.gif
// module id = shKH
// module chunks = 0